<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>系统管理</el-breadcrumb-item>
			<el-breadcrumb-item>工序管理</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item label="搜索">
					<el-input v-model="keyword" placeholder="按名称搜索">
						<i slot="prefix" class="el-input__icon el-icon-search"></i>
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="info" @click="search">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新建</el-button>
				</el-form-item>
			</el-form>
		</div>

		<el-table border :data="tableData" style="width: 100%">
			<el-table-column type="index" label="序号" width="50"> </el-table-column>
			<el-table-column prop="name" label="工序名称"> </el-table-column>
			<el-table-column label="进料方向" width="150">
				<template slot-scope="scope">
					<span v-text="getDirectionName(scope.row.is_end_in)"></span>
				</template>
			</el-table-column>
			<el-table-column label="设置" width="150">
				<template slot-scope="scope">
					<div>
						<el-button type="text" icon="el-icon-edit" v-on:click="edit(scope.row)" style="margin-right:10px;">编辑</el-button>
						<el-popconfirm title="确定删除吗？" @onConfirm="remove(scope.row)">
							<el-button type="text" icon="el-icon-delete" slot="reference">删除</el-button>
						</el-popconfirm>
					</div>
				</template>
			</el-table-column>
		</el-table>

		<!--分页-->
		<el-pagination layout="sizes, prev, pager, next, total" :page-count="pageCount" :page-sizes="[10, 50, 100, 200]" :size="pageSize" @current-change="currentChange" @size-change="sizeChange"> </el-pagination>

		<!-- 编辑机台信息  -->
		<el-dialog :title="formDialogTitle" :visible.sync="formDialogVisable" width="500px">
			<div>
				<el-form ref="processForm" :rules="rules" :model="form" label-position="right" label-width="80px">
					<el-form-item label="工序名称" prop="name">
						<el-input v-model.trim="form.name" placeholder="工序名称"></el-input>
					</el-form-item>
					<el-form-item label="进料方向" prop="is_end_in">
						<el-select v-model.trim="form.is_end_in" clearable placeholder="进料方向">
							<el-option v-for="item in directions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="formDialogVisable = false">取消</el-button>
				<el-button type="primary" v-on:click="save('processForm')">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { processInfoRequest } from '@/network/requests/processInfo'
	export default {
		data() {
			this.directions = [
				{
					value: 0,
					label: '头进尾出',
				},
				{
					value: 1,
					label: '尾进头出',
				},
				{
					value: 2,
					label: '不限',
				},
			]

			return {
				tableData: [],
				keyword: '',
				pageSize: 10,
				pageIndex: 1,
				pageCount: 1,
				formDialogVisable: false,
				formDialogTitle: '编辑工序',
				form: {},
				rules: {
					name: [{ required: true, message: '请输入工序名称', trigger: 'blur' }],
					is_end_in: [{ required: true, message: '请选择进料方向', trigger: 'change' }],
				},
			}
		},
		methods: {
			/**
			 * 添加。
			 */
			handleAdd() {
				this.form = ''
				this.formDialogTitle = '添加新工序'
				this.formDialogVisable = true
				this.form = {
					is_end_in: 0,
				}
			},
			search() {
				this.pageIndex = 1
				this.query()
			},
			/**
			 * 查询。
			 */
			query() {
				processInfoRequest.searchPage(this.pageSize, this.pageIndex, { name: this.keyword }).then(res => {
					console.log('工序', res)
					this.tableData = res.data._embedded
					this.pageCount = res.data._total_pages
				})
			},
			/**
			 * 切换页码。
			 */
			currentChange(pageIndex) {
				this.pageIndex = pageIndex

				this.query()
			},
			/**
			 * 内容数量切换。
			 */
			sizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageIndex = 1
				this.query()
			},
			/**
			 * 保存工序
			 */
			save(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						console.log('保存工序', this.form)
						processInfoRequest.upload(this.form).then(res => {
							console.log('保存工序', res)
							this.formDialogVisable = false
							//重新加载内容。
							this.pageIndex = 1
							this.query()
						})
					} else {
						return false
					}
				})
			},
			/**
			 * 删除。
			 */
			remove(row) {
				processInfoRequest.deleteById(row._id.$oid).then(res => {
					console.log(res)

					this.pageIndex = 1
					this.query()
				})
			},
			/**
			 * 编辑。
			 */
			edit(row) {
				this.form = row
				this.formDialogTitle = '编辑工序'
				this.formDialogVisable = true
			},
			/**
			 * 获取进料方向名称。
			 */
			getDirectionName(val) {
				var array = this.directions.filter(t => t.value == val)
				if (array) {
					return array[0].label
				}

				return ''
			},
		},
		created() {
			this.query()
		},
	}
</script>

<style></style>
